// Model.js
// -----------------------
// @module Case
define("SuiteDB.SDBOtherCharges.SDBOtherCharges.Model", [
  "Backbone",
  "SCModel",
  "Utils",
  "underscore",
  "Singleton",
], function (Backbone, SCModelComponent, Utils, _, Singleton) {
  "use strict";
  var SCModel = SCModelComponent.SCModel;

  function SDBQuoteImprovementModel() {
    SCModel.call(this);

    //@property {String} urlRoot
    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath("services/SDBOtherCharges.Service.ss")
      );
    };
  }
  SDBQuoteImprovementModel.prototype = Object.create(SCModel.prototype);
  SDBQuoteImprovementModel.prototype.constructor = SDBQuoteImprovementModel;
  return _.extend(SDBQuoteImprovementModel, Singleton);
});
